// extracted by mini-css-extract-plugin
module.exports =  {"portfolioWrapper":"portfolioWrapper___Wvt7Y","title":"title___T7wyu"};